import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useQuotaStatus } from "./useQuotaStatus";

const getEducationKey = (userId: string) => `storydoodle-quota-education-shown-${userId}`;

export function useFirstTimeEducation() {
    const [hasManuallyDismissed, setHasManuallyDismissed] = useState(false);
    const { user } = useAuth();

    const { data: quotaData } = useQuotaStatus();

    // Check if this is their first story for current quota
    const hasNoUsedStoriesForQuota = quotaData?.stories.used === 0;

    // Check if they've already seen the education
    const hasSeenEducation = user ? localStorage.getItem(getEducationKey(user.id)) === "true" : false;

    // Don't show education for bypass users (they don't need quota information)
    const isBypassUser = quotaData?.bypassQuota;

    // Show education if: no stories for quota + hasn't seen education + hasn't manually dismissed + not bypass user
    const shouldShowEducation = hasNoUsedStoriesForQuota && !hasSeenEducation && !hasManuallyDismissed && !isBypassUser;

    const markEducationSeen = () => {
        if (user) {
            localStorage.setItem(getEducationKey(user.id), "true");
            setHasManuallyDismissed(true);
        }
    };

    const dismissEducation = () => {
        setHasManuallyDismissed(true);
    };

    return {
        shouldShowEducation,
        markEducationSeen,
        dismissEducation,
        storiesUsed: quotaData?.stories.used || 0,
        storiesLimit: quotaData?.stories.limit || 10,
    };
}
